export function hexToDecimal(hex) {
  return hex && typeof hex === 'string' && typeof hex.replace === 'function'
    ? parseInt(hex.replace('#', ''), 16)
    : parseInt('FFFFFF', 16);
}
export function hexToR(h) {
  return parseInt(this.cutHex(h).substring(0, 2), 16);
}
export function hexToG(h) {
  return parseInt(this.cutHex(h).substring(2, 4), 16);
}
export function hexToB(h) {
  return parseInt(this.cutHex(h).substring(4, 6), 16);
}
export function cutHex(h) {
  return h.charAt(0) == '#' ? h.substring(1, 7) : h;
}
export function rgbaStringToHex(rgbaString) {
  var colors = rgbaString.match(/\d+/g);
  colors = colors.slice(0, 3);
  let funcInput = {
    R: colors[0],
    G: colors[1],
    B: colors[2],
  };

  return rgbToHex(funcInput);
}
export function rgbToHex(rgb) {
  return toHex(rgb.R) + toHex(rgb.G) + toHex(rgb.B);
}
export function hsv2Hex(h, s, v) {
  var hsv_h = Number(h);
  var hsv_s = Number(s);
  var hsv_v = Number(v);

  var i = Math.floor(hsv_h * 6);
  var f = hsv_h * 6 - i;
  var p = hsv_v * (1 - hsv_s);
  var q = hsv_v * (1 - f * hsv_s);
  var t = hsv_v * (1 - (1 - f) * hsv_s);

  var rgb_r = 0,
    rgb_g = 0,
    rgb_b = 0;
  switch (i % 6) {
    case 0:
      rgb_r = hsv_v;
      rgb_g = t;
      rgb_b = p;
      break;
    case 1:
      rgb_r = q;
      rgb_g = hsv_v;
      rgb_b = p;
      break;
    case 2:
      rgb_r = p;
      rgb_g = hsv_v;
      rgb_b = t;
      break;
    case 3:
      rgb_r = p;
      rgb_g = q;
      rgb_b = hsv_v;
      break;
    case 4:
      rgb_r = t;
      rgb_g = p;
      rgb_b = hsv_v;
      break;
    case 5:
      ((rgb_r = hsv_v), (rgb_g = p), (rgb_b = q));
      break;
  }

  let rgb = {
    R: Math.floor(rgb_r * 255),
    G: Math.floor(rgb_g * 255),
    B: Math.floor(rgb_b * 255),
  };

  return rgbToHex(rgb);
}

export function toHex(n) {
  n = parseInt(n, 10);
  if (isNaN(n)) return '00';
  n = Math.max(0, Math.min(n, 255));
  return (
    '0123456789ABCDEF'.charAt((n - (n % 16)) / 16) +
    '0123456789ABCDEF'.charAt(n % 16)
  );
}

export function DecimalToHex(decimal) {
  let hex = parseFloat(decimal).toString(16);
  while (hex.length < 6) {
    hex = '0' + hex;
  }
  return `#${hex}`;
}

export function rgbaToRgb(rgba) {
  var colors = rgba.match(/\d+/g);
  return 'rgb(' + colors.slice(0, 3).join(',') + ')';
}
export function rgbaToAlpha(rgba) {
  return rgba.replace(/^.*,(.+)\)/, '$1');
}

export function rgbToRgba(rgb, alpha) {
  var colors = rgb.match(/\d+/g);
  return 'rgba(' + colors.join(',') + ',' + alpha + ')';
}

export function decimalToRgba(num, forceAlpha = undefined) {
  num >>>= 0;
  var b = num & 0xff,
    g = (num & 0xff00) >>> 8,
    r = (num & 0xff0000) >>> 16,
    a = ((num & 0xff000000) >>> 24) / 255;
  if (forceAlpha != undefined) {
    a = forceAlpha;
  } else if (a === 0) {
    a = 1;
  }
  return 'rgba(' + [r, g, b, a].join(',') + ')';
}
